export default {
    lotteryQr: ' Lotterie-QR-Code',
    checkResult: ' Prüfergebnis muss',
    downloadApp: ' APP herunterladen',
    prize: 'Preis',
    introTitle: 'How to conduct a lottery and claim prizes',
    lotteryRule: ' Lotterieregel',
    checkDetailsHint: '（Klicken Sie hier, um Details anzuzeigen）',
    addCardHint1: 'Fügen Sie Ihre',
    addCardHint2: 'Karte zu Laidan hinzu',
    howGetCard: 'Wie erhalten Sie Ihre Karte',
    getCardText: 'Sie können Ihre Karte über die kostenlose mobile App Laidan erhalten',
    flowTitle1: 'Laidan herunterladen',
    flowText1: 'Wenn Sie Laidan nicht haben, können Sie es verwenden, um Ihre Brieftasche schlanker zu machen',
    flowTitle2: 'Fügen Sie Ihre Karte hinzu',
    flowText2: 'Sobald Sie Laidan installiert haben, klicken Sie auf diese Schaltfläche, um die Karte zur App hinzuzufügen!',
    flowTitle3: 'Alles erledigt!',
    flowText3: 'Genießen Sie Ihr verbessertes mobiles Einkaufserlebnis!',
    flowBtnText1: 'Erhalten',
    flowBtnText2: 'Herunterladen von',
    flowBtnText3: 'Hinzufügen zu',
    merchantOs: 'Ihr eigenes Händlersystem',
    howCreateOs: 'Wie erstellen Sie Ihr System',
    createOsText: 'Sie können Ihre Waren verwalten und ein Mitgliedssystem mit der kostenlosen mobilen App Joinku erstellen',
    kuTitle1: 'Joinku herunterladen',
    kuText1: 'Wenn Sie Joinku nicht haben, können Sie es verwenden, um wertvolle Zeit zu sparen',
    kuTitle2: 'Ihr System anzeigen',
    kuText2: 'Sobald Sie Joinku installiert haben, klicken Sie auf diese Schaltfläche, um Mitglieder und Bestellungen anzuzeigen!',
    kuTitle3: 'Alles erledigt!',
    kuText3: 'Genießen Sie Ihr verbessertes Systemverwaltungserlebnis!',
    taxExpert: 'Ihr elektronischer Steuerexperte',
    howGetTax: 'Wie erhalten Sie Ihre elektronische Rechnung',
    getTaxText: 'Sie können Ihre elektronische Rechnung und an Händlerverlosungen teilnehmen über die kostenlose mobile App Laidan erhalten',
    danTitle1: 'Laidan herunterladen',
    danText1: 'Wenn Sie Laidan nicht haben, können Sie es verwenden, um von mehr Angeboten zu profitieren!',
    danTitle2: 'Ihre Angebote durchsuchen',
    danText2: 'Sobald Sie Laidan installiert haben, klicken Sie auf diese Schaltfläche, um an Ihren Angeboten teilzunehmen!',
    danText3: 'Genießen Sie Ihr verbessertes mobiles Angebotserlebnis!',
    inviteCashDedu: 'Bargeldrabatt durch Einladung',
    inviteCode: 'Einladungscode',
    copyInviteCode: 'Klicken Sie hier, um den Einladungscode zu kopieren!',
    copySucceed: 'Erfolgreich kopiert!',
    copyError: 'Kopieren fehlgeschlagen!',
    memberSystem: 'Mitgliedssystem',
    memberSystemText: 'Für jeden neuen Benutzer, den Sie mit Ihrem Einladungscode zur Registrierung als Joinku-Benutzer einladen, erhalten Sie einen Rabatt von 100 € auf die Jahresgebühr',
    inviteTitle2: 'Einladungscode einrichten',
    inviteText2: 'Sobald Sie Joinku installiert haben, kopieren Sie zuerst den Einladungscode und',
    inviteText3: 'Erhalten Sie eine jährliche Bargeldermäßigung!',
    flowBtnText4: 'Anschauen',
    phoneLabel: 'Telefon:',
    addressLabel: 'Adresse:',
    readAndAccept: 'lesen und akzeptieren',
    privacyPolicy: 'Datenschutzrichtlinie',
    startLottery: 'Lotterie starten',
    usePhoneLogin: 'Melden Sie sich mit der Handynummer an',
    useEmailLogin: 'Melden Sie sich per E-Mail an',
    phoneLogin: 'Anmeldung per Handynummer',
    countryCodeSearch: 'Geben Sie den Namen des Landes und die Ortsvorwahl ein, um zu suchen',
    emailLogin: 'E-Mail-Login',
    getAuthCode: 'Verifizierungscode erhalten',
    inpPhoneHint: 'Bitte geben Sie die Telefonnummer ein',
    inpEmailHint: 'Bitte geben Sie Ihr E-Mail-Konto ein',
    inpAuthCode: 'Bitte geben Sie den Bestätigungscode ein',
    codeVerifyTitle: 'Bitte führen Sie die Sicherheitsüberprüfung durch',
    codeVerifyHint: 'Wischen Sie nach rechts, um die Verifizierung abzuschließen',
    verifyError: 'Überprüfung fehlgeschlagen',
    verifyFinish: 'Überprüfen Sie vollständig',
    login: 'Anmeldung',
    clickCheck: 'Klicke um es zu sehen',
    downAppPrize: 'Laden Sie die APP herunter, um die Preise anzuzeigen',
    lottoErrorHint: 'Falscher Lotteriecode',
    lottoNoloHint: 'Bitte warte geduldig',
    lottoNowiHint: 'Tut mir leid, dass ich nicht gewonnen habe',
    lottoWinnHint: 'Herzlichen Glückwunsch zum Gewinn des Preises!!!',
    lottoUsedHint: 'Dieser Lotteriecode wurde bereits verwendet',
    partPlatLotto: 'Willkommen zur Teilnahme an der Plattform-Lotterie',
    skipPlatLotto: 'Dann springen Sie automatisch zur Plattform-Lotterieseite',
    skipPrize: 'Springe automatisch zur Gewinnseite',
    allowMerRead: 'Erlauben Sie Händlern den Zugriff auf meine Informationen:',
    infoMore: 'Name, Telefonnummer, Geburtstag',
    joinMember: 'Mitglied beitreten',
    checkMember: 'Mitglieder anzeigen',
    drawPlatCoupon: 'Erhalten Sie Plattform-Gutscheine',
    moreDisDis: 'Weitere Rabatte',
    firLoginDraw: 'Wenn Sie sich zum ersten Mal bei der APP anmelden, können Sie Folgendes erhalten',
    clickDown: 'Klicken Sie hier, um die APP',
    appDraw: 'herunterzuladen und zu erhalten',
    validTime: 'Gültig bis',
    useAwaCodeHint: 'Bitte verwenden Sie ihn bei Ihrer nächsten Mahlzeit und legen Sie den Barcode an der Kasse vor',
    platLottoCode: 'Plattform-Lotteriecode',
    lottoCode: 'Glücksziehungscode:',
    lotteryTime: 'Zeit zeichnen: ',
    noLottery: 'Nicht gezeichnet',
    yetWinning: 'Hat gewonnen',
    noWinning: 'Nicht gewonnen',
    haveUsed: 'Gebraucht',
    sellOut: 'Ausverkauft',
    currentPrice: 'Datum / Uhrzeit einstellen',
    includeAllergen: 'Enthält Allergene',
    details: 'Bestelldaten',
    selectAllergen: 'Auftrag in Bearbeitung',
    rawMaterials: 'rohes Material:',
    cookingWay: 'Produktionsmethode:',
    allergens: 'Enthält Allergene:',
    mayAddMaterials: 'Addierbare Inhaltsstoffe:',
    mayMinusMaterials: 'Kann Zutaten reduzieren:',
    taste: 'Geschmackspräferenz:',
    selectedGroupNum: 'Ausgewählte Plattenmengen:',
    priceZero: 'Gerichte zum Preis von 0',
    priceNoZero: 'Gerichte mit einem Preis ungleich 0',
    notSetMealDishes: 'Keine Gerichte in diesem Menü',
    notGroupDishes: 'Keine Gerichte in dieser Kategorie',
    notDishesMat: 'Keine Rohstoffe in diesem Gericht',
    notGroupMat: 'Keine Rohstoffe in dieser Kategorie',
    selectFinish: 'Ausgewählt',
    noSelectFinish: 'Zur Auswahl',
    cancel: 'Stornieren',
    woka: {
        activityPage: 'Veranstaltungsseite',
        unlockDish: 'Gerichte kostenlos freischalten',
        unlockText: 'Nehmen Sie gemäß den Veranstaltungsregeln am Sharing-Event teil, um ein beliebiges Gericht kostenlos freizuschalten!',
        activityRule: 'Veranstaltungsregeln',
        ruleText: 'Wählen Sie eine der folgenden Methoden, laden Sie einen Screenshot an der angegebenen Stelle hoch und erhalten Sie einen Code zum Einlösen eines Gerichts.',
        issueWork: 'Inhalt veröffentlichen',
        weChat: 'WeChat',
        wechatText: 'Teilen Sie in Ihrem Profil und sammeln Sie 20 "Gefällt mir" von Freunden.',
        douyinText1: '1. Nehmen Sie am Thema #AICookingAssistant# teil',
        douyinText2: '2. Angehängter Kommentar',
        douyinText3: '3. Veröffentlichen Sie auf TikTok @xxxx',
        redBook: 'Xiaohongshu',
        redBookText2: '2. Markieren Sie Ihren Standort',
        instagramText1: '1. Veröffentlichen Sie eine öffentliche Story + Post/Reels',
        instagramText2: '2. @Erwähnen Sie 3 Freunde',
        tikTokText1: '1. Temporäre Story',
        tikTokText2: '2. Öffentliches Werk @Erwähnen Sie 3 Freunde',
        partActivity: 'Nehmen Sie an der Veranstaltung teil',
    }
};
